/**
 * Extension fields for the External Agent
 */ export class ExternalAgentsExtensions {
    constructor(agents){
        this.agents = agents;
    }
}
